import { useEffect, useState } from "react";
import ikas from "../../providers/ikas";
import { BasketIcon, HeartIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import * as compSettings from "./settings";
import config from "../../config";

const ProductCard = ({
  product,
  onCartIconClick,
  onWishlistIconClick,
  onProductClick,
  isFavorite,
  id,
  extendedSettings,
}) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };
  const variant = product.variants?.[0];
  const imageUrl = `https://cdn.myikas.com/images/${config.MERCHANT_ID}/${variant?.images?.[0]?.id}/image_540.webp`;
  const prices = variant?.prices?.[0]; //TODO:priceListId'ye göre seç
  const discount = prices?.discountPrice
    ? "%" +
    Number(
      ((prices?.sellPrice - prices?.discountPrice) / prices?.sellPrice) * 100
    ).toFixed(0) +
    " İNDİRİM"
    : "";
  const selectedTotalStock = variant?.stocks?.reduce(
    (totalValue, currentValue) => {
      return totalValue + currentValue.stockCount;
    },
    0
  );
  const isAvailable = selectedTotalStock > 0 || variant?.availableForSale;

  // Settings'ten değerleri al
  const cardBackgroundColor = settings.cardBackgroundColor.value;
  const cardBorderColor = settings.cardBorderColor.value;
  const cardShadowColor = settings.cardShadowColor.value;
  const productTitleColor = settings.productTitleColor.value;
  const priceColor = settings.priceColor.value;
  const oldPriceColor = settings.oldPriceColor.value;
  const discountBadgeColor = settings.discountBadgeColor.value;
  const discountTextColor = settings.discountTextColor.value;
  const iconColor = settings.iconColor.value;
  const iconBackgroundColor = settings.iconBackgroundColor.value;
  const favoriteIconColor = settings.favoriteIconColor.value;
  const unavailableOpacity = settings.unavailableOpacity.value;
  const cardPadding = settings.cardPadding.value + "px";
  const cardBorderRadius = settings.cardBorderRadius.value + "px";
  const cardBorderWidth = settings.cardBorderWidth.value + "px";
  const cardWidth = settings.cardWidth.value + "px";
  const imageHeight = settings.imageHeight.value + "px";
  const productTitleFontSize = settings.productTitleFontSize.value + "px";
  const productTitleFontWeight = settings.productTitleFontWeight.value;
  const productTitleMinHeight = settings.productTitleMinHeight.value + "px";
  const priceFontSize = settings.priceFontSize.value + "px";
  const oldPriceFontSize = settings.oldPriceFontSize.value + "px";
  const discountFontSize = settings.discountFontSize.value + "px";
  const iconSize = settings.iconSize.value;
  const iconPadding = settings.iconPadding.value + "px";
  const iconBorderRadius = settings.iconBorderRadius.value + "%";
  const showShadow = settings.showShadow.value;
  const showBorder = settings.showBorder.value;
  const showDiscountBadge = settings.showDiscountBadge.value;
  const showFavoriteIcon = settings.showFavoriteIcon.value;
  const showCartIcon = settings.showCartIcon.value;
  const showOldPrice = settings.showOldPrice.value;

  const getBoxShadow = () => {
    if (!showShadow) return "none";
    return `0 1px 3px ${cardShadowColor}`;
  };

  return (
    <div
      onClick={onProductClick}
      key={product.id}
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: cardBackgroundColor,
        borderRadius: cardBorderRadius,
        boxShadow: getBoxShadow(),
        width: cardWidth,
        border: showBorder
          ? `${cardBorderWidth} solid ${cardBorderColor}`
          : "none",
        position: "relative",
        opacity: isAvailable ? "1" : unavailableOpacity,
        cursor: "pointer",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          left: "8px",
          display: "flex",
          justifyContent: "space-between",
          zIndex: 10,
        }}
      >
        {showCartIcon && (
          <button
            style={{
              color: iconColor,
              backgroundColor: iconBackgroundColor,
              borderRadius: iconBorderRadius,
              padding: iconPadding,
              border: "none",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              onCartIconClick();
            }}
          >
            <BasketIcon color={iconColor} size={iconSize} />
          </button>
        )}
        {showFavoriteIcon && (
          <button
            style={{
              color: iconColor,
              backgroundColor: iconBackgroundColor,
              borderRadius: iconBorderRadius,
              padding: iconPadding,
              border: "none",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              onWishlistIconClick();
            }}
          >
            <HeartIcon
              color={isFavorite ? favoriteIconColor : iconColor}
              size={iconSize}
              weight={isFavorite ? "fill" : "regular"}
            />
          </button>
        )}
      </div>
      <img
        src={imageUrl}
        alt={product.name}
        style={{
          width: "100%",
          height: imageHeight,
          objectFit: "cover",
          marginBottom: "8px",
          backgroundColor: "#f9fafb",

        }}
        draggable={false}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingLeft: cardPadding,
          paddingRight: cardPadding,
          paddingBottom: cardPadding,
        }}
      >
        <div
          style={{
            fontWeight: productTitleFontWeight,
            color: productTitleColor,
            fontSize: productTitleFontSize,
            marginBottom: "12px",
            minHeight: productTitleMinHeight,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {product.name}
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {showOldPrice && prices?.discountPrice && (
            <span
              style={{
                color: oldPriceColor,
                fontSize: oldPriceFontSize,
                textDecoration: "line-through",
              }}
            >
              ₺
              {parseFloat(prices?.sellPrice).toLocaleString("tr-TR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          )}
          <span
            style={{
              color: priceColor,
              fontSize: priceFontSize,
              fontWeight: "700",
            }}
          >
            ₺
            {parseFloat(
              prices?.discountPrice ?? prices?.sellPrice
            ).toLocaleString("tr-TR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
      </div>
      {showDiscountBadge && discount && (
        <div
          style={{
            backgroundColor: discountBadgeColor,
            color: discountTextColor,
            fontSize: discountFontSize,
            fontWeight: "900",
            borderBottomLeftRadius: cardBorderRadius,
            borderBottomRightRadius: cardBorderRadius,
            paddingLeft: cardPadding,
            paddingRight: cardPadding,
            paddingTop: "4px",
            paddingBottom: "4px",
            textAlign: "center",
            width: "100%",
          }}
        >
          {discount}
        </div>
      )}
    </div>
  );
};

const ProductSlider = ({ extendedSettings, id, data, dataSetter }) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(true);
  const [page, setPage] = useState(1);

  // Quick Buy modal states
  const [quickBuyProduct, setQuickBuyProduct] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [quickBuyVisible, setQuickBuyVisible] = useState(false);
  const [quickBuyModalVisible, setQuickBuyModalVisible] = useState(false);
  const [quickBuyLoading, setQuickBuyLoading] = useState(false);
  const [quickBuyToast, setQuickBuyToast] = useState("");
  const [showQuickBuyToast, setShowQuickBuyToast] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [cartModalVisible, setCartModalVisible] = useState(false);

  const navigation = useNavigate();

  // Settings'ten değerleri al
  const titleColor = settings.titleColor.value;
  const titleFontSize = settings.titleFontSize.value + "px";
  const titleFontWeight = settings.titleFontWeight.value;
  const containerBackgroundColor = settings.containerBackgroundColor.value;

  const titleMarginBottom = settings.titleMarginBottom.value + "px";
  const sliderPadding = settings.sliderPadding.value + "px";
  const cardSpacing = settings.cardSpacing.value + "px";
  const marginTop = settings.marginTop.value+ "px";
  const marginBottom = settings.marginBottom.value+ "px";
  const showTitle = settings.showTitle.value;
  const horizontalScroll = settings.horizontalScroll.value;
  const loadingAnimation = settings.loadingAnimation.value;
  const centerTitle = settings.centerTitle.value;
  const snapToCard = settings.snapToCard.value;

  // Settings'ten type, value ve title değerlerini al - prop'larla override edilebilir
  const sliderValue = JSON.parse(settings?.category?.value)?.[0].id;
  const sliderTitle = settings?.sliderTitle?.value;

  const onCartIconClick = (product) => {
    let productVariantsHashMap = {};
    product.variants.forEach((variant) => {
      let key = "";
      variant.variantValues.forEach((vv) => {
        key += vv.variantTypeId + vv.variantValueId + "/";
      });
      if (key.endsWith("/")) key = key.slice(0, -1);
      productVariantsHashMap[key] = { ...variant, key };
    });
    const firstVariantKey = Object.keys(productVariantsHashMap)[0];
    const firstVariant = productVariantsHashMap[firstVariantKey];
    setSelectedVariant(firstVariant);
    setQuickBuyProduct({ ...product, variantMap: productVariantsHashMap });

    setQuickBuyVisible(true);
    setTimeout(() => setQuickBuyModalVisible(true), 10);
  };

  const onWishlistIconClick = (product) => {
    let newFavorites = [...data.favorites];
    if (data?.favorites?.includes(product.id)) {
      newFavorites = data.favorites.filter((id) => id !== product.id);
    } else {
      newFavorites.push(product.id);
    }
    dataSetter({
      key: "favorites",
      value: newFavorites,
    });
    localStorage.setItem("favorites", JSON.stringify(newFavorites));
  };
  const onProductClick = (product) => {
    navigation(`/product`, {
      state: product,
    });
  };
  const fetchProducts = async (isLoadMore = false) => {
    if (loading || loadingMore || !sliderValue) return;

    if (isLoadMore && !hasNextPage) return;
    if (isLoadMore) setLoadingMore(true);
    else setLoading(true);
    try {
      let input = {};
      input = {
        categoryIdList: [sliderValue],
        page: page,
        perPage: 20,
      };

      const data = await ikas.searchProducts(input);

      const result = data.results;

      setPage((prev) => prev + 1);
      setProducts((prev) => (isLoadMore ? [...prev, ...result] : result));
      setHasNextPage(data.totalCount > page * 20);
    } catch (err) {
      console.error(err);
    } finally {
      if (isLoadMore) setLoadingMore(false);
      else setLoading(false);
    }
  };

  useEffect(() => {
    setProducts([]);
    setHasNextPage(true);
    fetchProducts(false);
    // eslint-disable-next-line
  }, [sliderValue]);

  // Scroll event: slider'ın sonuna gelince daha fazla ürün çek
  const handleScroll = (e) => {
    const { scrollLeft, scrollWidth, clientWidth } = e.target;

    if (
      scrollWidth - scrollLeft - clientWidth < 40 &&
      hasNextPage &&
      !loadingMore
    ) {
      fetchProducts(true);
    }
  };

  if (loading && loadingAnimation) {
    return (
      <div className="w-full">
        <h3 className="mb-2 font-semibold text-lg">{sliderTitle}</h3>
        <div className="flex overflow-x-auto gap-3 pb-2 hide-scrollbar">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="flex flex-col bg-white rounded-lg shadow p-2 min-w-[180px] max-w-[200px] w-[180px] border border-gray-200 animate-pulse"
            >
              <div className="flex justify-between mb-1">
                <div className="w-6 h-6 bg-gray-200 rounded-full" />
                <div className="w-6 h-6 bg-gray-200 rounded-full" />
              </div>
              <div className="w-full h-32 bg-gray-200 mb-2 rounded" />
              <div className="h-4 bg-gray-200 rounded mb-3 w-5/6" />
              <div className="flex flex-col mb-1 gap-1">
                <div className="h-4 bg-gray-200 rounded w-1/2" />
                <div className="h-4 bg-gray-200 rounded w-2/3" />
              </div>
              <div className="h-5 bg-gray-200 rounded w-1/2 mx-auto mt-2" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: containerBackgroundColor,
        marginTop: marginTop,
        marginBottom: marginBottom,
      }}
    >
      {showTitle && (
        <h3
          style={{
            marginBottom: titleMarginBottom,
            textAlign: "center",
            fontWeight: titleFontWeight,
            fontSize: titleFontSize,
            color: titleColor,
          }}
        >
          {sliderTitle}
        </h3>
      )}
      <div
        style={{
          display: "flex",
          overflowX: horizontalScroll ? "auto" : "visible",
          gap: cardSpacing,
          paddingBottom: sliderPadding,
          paddingLeft: sliderPadding,
          paddingRight: sliderPadding,
          scrollBehavior: "smooth",
          scrollSnapType: snapToCard ? "x mandatory" : "none",
        }}
        className="hide-scrollbar"
        onScroll={handleScroll}
      >
        <style>
          {`
            .hide-scrollbar::-webkit-scrollbar { display: none; }
            .hide-scrollbar { 
              scrollbar-width: none; 
              -ms-overflow-style: none; 
            }
            .product-card { 
              scroll-snap-align: ${snapToCard ? "start" : "none"}; 
            }
          `}
        </style>
        {products.map((product) => {
          const isFavorite = data.favorites.includes(product.id);
          return (
            <div key={product.id} className="product-card">
              <ProductCard
                product={product}
                isFavorite={isFavorite}
                extendedSettings={extendedSettings}
                id={id}
                onCartIconClick={() => onCartIconClick(product)}
                onWishlistIconClick={() => onWishlistIconClick(product)}
                onProductClick={() => onProductClick(product)}
              />
            </div>
          );
        })}
        {loadingMore && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",

            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                border: "4px solid #e5e7eb",
                borderTop: "4px solid #000000",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        )}
      </div>

      {/* Quick Buy Modal */}
      {quickBuyVisible && quickBuyProduct && (
        <div
          className="fixed inset-0 z-[200] flex flex-col justify-end bg-black bg-opacity-40"
          onClick={() => {
            setQuickBuyModalVisible(false);
            setTimeout(() => setQuickBuyVisible(false), 300);
          }}
        >
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6  relative transition-all duration-300 ${quickBuyModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
              }`}
            style={{ minHeight: 200 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-3 right-3 flex gap-2">
              <button
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
                onClick={() => {
                  setQuickBuyModalVisible(false);
                  setTimeout(() => setQuickBuyVisible(false), 300);
                }}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            <div className="flex items-center px-6 pt-1 pb-4">
              <div>
                <div className="font-bold text-lg">{quickBuyProduct.name}</div>
                {selectedVariant?.selectedOptions?.map((option) => (
                  <div key={option.name} className="text-sm text-gray-700">
                    {option.name}: {option.value}
                  </div>
                ))}
              </div>
            </div>

            {/* Options selector */}
            <div className="px-6 pb-4">
              {quickBuyProduct.productVariantTypes?.map(
                ({ variantType }, index) => {
                  return (
                    variantType.values.length > 1 && (
                      <div key={index} className="mb-4">
                        <div className="grid grid-cols-4 gap-3">
                          {variantType.values.map((value) => {
                            const splittedSelectedVariantKey =
                              selectedVariant.key.split("/");
                            splittedSelectedVariantKey[index] =
                              variantType.id + value.id;
                            let key = splittedSelectedVariantKey.join("/");

                            const variant = quickBuyProduct.variantMap[key];
                            const variantStock = variant?.stocks?.reduce(
                              (totalValue, currentValue) => {
                                return totalValue + currentValue.stockCount;
                              },
                              0
                            );
                            const isSelected = selectedVariant.key === key;
                            const isAvailable =
                              variantStock > 0 || variant?.availableForSale;

                            return (
                              <button
                                key={value.id}
                                onClick={() => {
                                  setSelectedVariant(variant);
                                }}
                                disabled={!isAvailable}
                                className={`h-12 rounded text-sm font-medium transition-colors duration-200 ${isSelected
                                    ? "bg-black text-white"
                                    : "bg-gray-100 text-black hover:bg-gray-200"
                                  } ${!isAvailable
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                  }`}
                              >
                                {value.name}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    )
                  );
                }
              )}
            </div>

            {/* Add to Cart Button */}
            <div className="px-6 pb-2">
              <button
                className="w-full bg-black text-white py-3 rounded-sm text-base font-bold"
                disabled={quickBuyLoading}
                onClick={async () => {
                  const cartId =
                    localStorage.getItem("cartId") ??
                    sessionStorage.getItem("cartId");
                  setQuickBuyLoading(true);
                  try {
                    const input = {
                      cartId,
                      salesChannelId: config.SALES_CHANNEL_ID,
                      storefrontThemeId: config.ROUTING_ID,
                      item: {
                        quantity: 1,
                        variant: {
                          id: selectedVariant.id,
                          name: quickBuyProduct.name,
                        },
                      },
                    };

                    const addResult = await ikas.addItemToCart(input);
                    console.log(addResult);
                    dataSetter(addResult);
                    setShowCartModal(true);
                    setTimeout(() => setCartModalVisible(true), 10);
                    setQuickBuyModalVisible(false);
                    setTimeout(() => setQuickBuyVisible(false), 300);
                  } catch (err) {
                    console.error(err);
                    setQuickBuyToast("Bir hata oluştu");
                    setShowQuickBuyToast(true);
                    setTimeout(() => setShowQuickBuyToast(false), 1500);
                  } finally {
                    setQuickBuyLoading(false);
                  }
                }}
              >
                Add to cart
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loading overlay for QuickBuy */}
      {quickBuyLoading && (
        <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black bg-opacity-60">
          <span className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
        </div>
      )}

      {/* Toast for QuickBuy */}
      {quickBuyToast && (
        <div
          className={`fixed left-1/2 transform -translate-x-1/2 z-[210] w-[95vw] max-w-xl bg-black text-white px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400 ${showQuickBuyToast
              ? "opacity-100 translate-y-0"
              : "opacity-0 -translate-y-4 pointer-events-none"
            }`}
          style={{ minWidth: 320, top: 20 }}
        >
          {quickBuyToast}
        </div>
      )}

      {/* Cart confirmation modal */}
      {showCartModal && selectedVariant && quickBuyProduct && (
        <div className="fixed inset-0 z-[300] flex flex-col justify-end bg-black bg-opacity-40">
          <div
            className={`w-full bg-white rounded-t-2xl shadow-lg py-6 px-4 flex flex-row items-center relative transition-all duration-300 ${cartModalVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-full opacity-0"
              }`}
            style={{ minHeight: 160 }}
          >
            <button
              className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-black text-2xl"
              onClick={() => {
                setCartModalVisible(false);
                setTimeout(() => setShowCartModal(false), 300);
              }}
              aria-label="Kapat"
            >
              ×
            </button>
            <img
              src={`https://cdn.myikas.com/images/${config.MERCHANT_ID}/${selectedVariant?.images?.[0]?.id}/image_540.webp`}
              alt={quickBuyProduct.title}
              className="w-20 h-20 object-contain rounded mr-4 flex-shrink-0"
            />
            <div className="flex flex-col flex-1 items-start">
              <div className="text-green-600 font-bold text-lg mb-1">
                Product Added
              </div>
              <div className="font-semibold text-sm mb-3">
                {quickBuyProduct.title}
                {selectedVariant.title &&
                  selectedVariant.title !== "Default Title" && (
                    <>
                      :{" "}
                      <span className="font-normal">
                        {selectedVariant.title}
                      </span>
                    </>
                  )}
              </div>
              <button
                className="w-full bg-black text-white py-2 rounded-lg font-bold mb-2"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                  navigation("/cart");
                }}
              >
                Go to cart
              </button>
              <button
                className="w-full bg-gray-100 text-black py-2 rounded-lg font-semibold"
                onClick={() => {
                  setCartModalVisible(false);
                  setTimeout(() => setShowCartModal(false), 300);
                }}
              >
                Continue shopping
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductSlider;
